import { DashboardModuleListItem } from '@domain-group/suit-theme'
import { generateRedirectUrl } from '@domain-group/javascript-utils'

import useCurrentUser from '@hooks/useCurrentUser'
import { generateUrls } from '@hooks/useAgency'
import { useRelations } from '@hooks/useAgencyProvider'

import type { AgencyProviderModel } from '@models/types'

interface AgencyListItemProps {
  agencyProvider: AgencyProviderModel,
}

const AgencyListItem = (props: AgencyListItemProps) => {
  const { agencyProvider } = props

  const {
    agency: {
      // @ts-expect-error TS2339
      id,
      // @ts-expect-error TS2339
      title,
    },
  } = useRelations(agencyProvider)

  const currentUserPayload = useCurrentUser()
  const { isProviderDirector } = currentUserPayload

  const { editAgencyRelationsUrl, editProviderAccountUrl } = generateUrls({ id })
  const editUrl = isProviderDirector ? editProviderAccountUrl : editAgencyRelationsUrl

  return (
    <DashboardModuleListItem title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AgencyListItem
